import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.title',
		defaultMessage: 'Validation has failed',
		description:
			'Title for the precondition error message, displayed when the currently saved widget settings are not valid',
	},
	firstLine: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.first-line',
		defaultMessage:
			'This Jira Service Management project has {length, plural, one {a configuration problem} other {configuration problems}} and may not work as expected.',
		description:
			'First line of the precondition error message, explaining that there are configuration problems in the selected request type. The fields of the request type which are causing the problem is shown below this line.',
	},
	lastLine: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.last-line',
		defaultMessage:
			'Try fixing {length, plural, one {the error} other {these errors}} then enable the widget.',
		description:
			'Last line of the precondition error message, explaining that the user needs to fix the errors on the fields shown above this line and then enable the widget',
	},
	missionPermissionErrorLearnLink: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.mission-permission-error-learn-link',
		defaultMessage: 'Learn how to change project permissions.',
		description:
			'Link to learn how to change project permissions, shown when the widget user does not have the required permissions to view the widget',
	},
	missionPermissionErrorSupportLink: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.mission-permission-error-support-link',
		defaultMessage: 'Still having trouble? <a>Create a support request.</a>',
		description:
			'Link to create a support request, shown when the widget user does not have the required permissions to view the widget',
	},
	anonymousAccessErrorSummary: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.anonymous-access-error-summary',
		defaultMessage: "Customers can't see widgets unless they can send requests without logging in.",
		description:
			'Summary of the anonymous access error message, explaining that the widget is not visible to customers who are not logged in',
	},
	anonymousAccessErrorDescription: {
		id: 'servicedesk-widget-settings.content.error-sections.precondition-error.anonymous-access-error-description',
		defaultMessage: 'Learn how to set up up a login-free portal.',
		description: 'Description of the anonymous access error message with a link to learn more',
	},
});
